import { Button, IconProps } from "@cloudscape-design/components-themed";
import {
  CancelableEventHandler,
  ClickDetail,
} from "@cloudscape-design/components-themed/internal/events";

interface IDownloadButton {
  iconName: IconProps.Name;
  label: string;
  disabled?: boolean;
  onClick: CancelableEventHandler<ClickDetail>;
}

/**
 * アイコン付きボタン
 */
export const IconButton = (props: IDownloadButton) => {
  const { iconName, label, disabled, onClick } = props;

  return (
    <Button
      iconName={iconName}
      formAction={"none"}
      variant={"normal"}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};
